// React 16 has no useId (added in React 18). Some @webmotors design-system
// packages (eleanor-ui, consumer-shared-ui) call it unconditionally, which
// crashes both SSR and the client bundle. This wraps the real React module
// (resolved via its file path so it bypasses the `react$` webpack alias
// pointing here) and adds a same-value-for-the-component-lifetime shim.
const React = require('react/index.js')

let idCounter = 0

function useId() {
  const ref = React.useRef(null)
  if (ref.current === null) {
    idCounter += 1
    ref.current = `:r${idCounter.toString(36)}:`
  }
  return ref.current
}

module.exports = Object.assign({}, React, {
  useId: typeof React.useId === 'function' ? React.useId : useId,
})
